import React, { useEffect, useState } from "react";
import axios from "axios";
import { Constants } from "../../CommonMethhods/Constants";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import HierarchyTable from "../../Components/ReportTables/HierarchyTable";
import Loader from "../../Components/Common/Loader";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import { AESEncryption, ApiResDecrypt, checkDateRange, compareDate, noDataFound } from "../../CommonMethhods/CommonMethods";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import moment from "moment";

function HierarchyReport() {
  const storeToken = localStorage.getItem("ssoToken");
  const [page, setPage] = useState(1);
  const [checkResp, setCheckResp] = useState([]);
  const [serverError, setServerError] = useState(false);
  const [count, setCount] = useState();
  const [error, setError] = useState(false);
  const [durationSet, setDuration] = useState("Yearly");
  const [isRmYesNo, setIsRmYesNo] = useState("No");
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [loader, setLoader] = useState(false);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorResp, setErrorResp] = useState("");


  if (fromDate === "" || toDate === "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();
    if (CurrentMonth < 4) {
      const newYear = `04-01-${CurrentYear - 1}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    } else {
      const newYear = `04-01-${CurrentYear}`;
      const date = `${
        current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
      const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
      setFromDate(newYear);
      setToDate(date1);
    }
  }

  const getHierarchyReport = async (
    fileType,
    sizePage,
    duration,
    pageNo = 1
  ) => {
    if (fileType === "excel") {
      setSmallLoaderExcel(true);
    }
    if (fileType === "pdf") {
      setSmallLoaderPdf(true);
    }
    if (page === 1 && fileType === "grid") {
      setLoader(true);
    }
    let payloadValue = {
      pageNo: pageNo,
      pageSize: sizePage,
      type: fileType,
      duration: duration,
      fromDate: duration == "customrange" ? fromDate : "",
      toDate: duration == "customrange" ? toDate : "",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getHierarchyDetails = await axios.post(
        Dashboard_Client_Report.Hierarchy_URL,

        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getHierarchyDetails?.data);

      setError(false);
      setServerError(false);
      if (res?.status === 0) {
        setServerError(false)
        if (fileType === "grid") {
          setIsRmYesNo(res?.data?.isRM);
          setCount(res?.data?.totalCount);
          if (page > 1) {
            setCheckResp((prev) => {
              return [...prev, ...res?.data?.hierarchyReports];
            });
          } else {
            setCheckResp(res?.data?.hierarchyReports);
          }
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setCheckResp([]);
        setServerError(res?.message);
        setError(res?.message);
      }
    } catch (error) {
      console.log(error);
      setCheckResp([]);
      setServerError(error?.message);
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
      setScrollLoader(false);
      setSmallLoaderPdf(false);
    }
  };

  const handleScroll = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  const handleOnChange = (e) => {
    if (e.target.value) {
      setDuration(e.target.value);
      setPage(1);
      setFromDate("");
      setToDate("");
      setCheckResp([]);
      setErrorResp("");
    }
  };

  useEffect(() => {
    if(durationSet !== "customrange"){
    getHierarchyReport("grid", 10, durationSet, page);
    }
  }, [page, durationSet]);

  const handleOnClick = (e) => {
    if (e.target.value) {
      if(compareDate(fromDate) &&
      compareDate(toDate) &&
      checkDateRange(fromDate, toDate)){
        setErrorResp("");
      getHierarchyReport(e.target.value, -1, durationSet, 1);
      }else{
        setErrorResp("Please Select Correct Date");
      }
    }
  };

  const handleOnSubmit = (e) => {
    if (e.target.value) {
      if(compareDate(fromDate) &&
      compareDate(toDate) &&
      checkDateRange(fromDate, toDate)){
        setErrorResp("");
      getHierarchyReport("grid", 10, durationSet, 1);
      }else{
        setErrorResp("Please Select Correct Date");
      }
    }
  };

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const handleFromDateChange = (e) => {
    // setDateErrorResp(false);
    setServerError(false);
    setCheckResp([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setErrorResp("");
  };

  const handleToDateChange = (e) => {
    // setDateErrorResp(false);
    setServerError(false);
    setCheckResp([]);
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setErrorResp("");
  };

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <h2 className="report-title">{Constants.Hierarchy_Report}</h2>
          <div className="row">
            <div className="col-md-4 col-sm-4 col-12">
              <div className="form-group">
                <label className="form-label">{Constants.Report_As_Per}</label>
                <select className="" onChange={handleOnChange}>
                  <option value="Yearly">Yearly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Daily">Daily</option>
                  <option value="customrange">Custom Date</option>
                </select>
              </div>
            </div>

            {durationSet === "customrange" &&
            <>
            <div className="col-md-4 col-sm-4 col-12">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>
            <div className="col-md-4 col-sm-4 col-12">
              <TodateComponent
                toDate={handleToDateChange}
                formatToDate={formatDate(toDate)}
                DateReverse={DateReverse}
                errorResponse={errorResp}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>
            </>
            }
          </div>
          <div>
            <ReportTableHeader
              handleOnClick={handleOnClick}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
            />
          </div>

            {durationSet === "customrange" &&
          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnSubmit}
            >
              {Constants.Submit}
            </button>
          </div>
}

          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : checkResp && checkResp?.length > 0 ? (
              <div>
                <HierarchyTable
                  checkResp={checkResp}
                  handleScroll={handleScroll}
                  scrollLoader={scrollLoader}
                  isRmYesNo={isRmYesNo}
                />
              </div>
            ) : (
              error &&
              !serverError && (
                <h4 className="report-error-message">{noDataFound(error)}</h4>
              )
            )}
            {!loader && serverError && (
              <h4 className="report-error-message">
                {noDataFound(serverError)}
              </h4>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default HierarchyReport;
